<template>
  <transition name="fade-transition" mode="out-in">
    <slot name='loader' v-if="isLoading === true">
      <template v-if="layout">
        <component :is="getLoaderComponent(layout)" v-bind="$attrs"/>
      </template>
      <template v-else>
        <skeleton-loader v-bind="$attrs" />
      </template>
    </slot>

    <div v-if="isLoading === false">
      <slot name='content' />
    </div>
  </transition>
</template>

<script>
import { SkeletonLoader, SkeletonTable } from '@/components/ContentLoader/components'
import { ContextLayout, DetailPageLayout } from '@/components/ContentLoader/layouts'

export default {
  name: 'ContentLoader',

  components: { SkeletonLoader },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: null
    }
  },

  methods: {
    getLoaderComponent (layout) {
      const layouts = {
        'context-layout': ContextLayout,
        'detail-page-layout': DetailPageLayout,
        'table-layout': SkeletonTable
      }

      return layouts[layout]
    }
  }
}
</script>
